module.exports = __webpack_public_path__ + "media/images/sample/product-12-e9d9356e98ab2c028260272d6ad3c87d.png";